module.exports = __webpack_public_path__ + "media/offers/gift-9e2e02d5.png";